export function getEntriesOfNumericEnum(ENUM: object): Array<[string, number]> {
    return Object.keys(ENUM)
        .map((key) => [key, ENUM[key]] as [string, number])
        .filter(([key, value]) => typeof key === 'string' && typeof value === 'number')
        .map((x) => x);
}
export function getValuesOfNumericEnum(ENUM: object) {
    return getEntriesOfNumericEnum(ENUM).map((item) => item[1]);
}

export function getKeyFromValueOfNumericEnum(ENUM: object, value: number) {
    const keyAndValue = getEntriesOfNumericEnum(ENUM).find(([key, currentValue]) => value === currentValue);

    if (keyAndValue) {
        return keyAndValue[0];
    }
    return undefined;
}

export function getEntriesOfStringEnum(ENUM: object): Array<[string, string]> {
    return Object.keys(ENUM).map((key) => [key, ENUM[key]] as [string, string]);
}

export function getValuesOfStringEnum(ENUM: object) {
    return getEntriesOfStringEnum(ENUM).map((item) => item[1]);
}
